require("!!/opt/courtyard/ci/front/node_modules/script-loader/addScript.js")(require("!!/opt/courtyard/ci/front/node_modules/raw-loader/index.js!/opt/courtyard/ci/front/node_modules/source-map-loader/index.js!/opt/courtyard/ci/front/src/assets/js/new/js/Plugin/asscrollable.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/new/js/Plugin/asscrollable.js
// module id = 420
// module chunks = 2